import { ExactPaySlippageTypes } from "../types";

// 0.1%, 0.25%, 0.5%, 0.75%, 1%
export const EXACT_PAY_MAX_SLIPPAGE_TABS = [
  {
    id: ExactPaySlippageTypes.MAX_SLIPPAGE_0_1,
    name: "0.1%",
  },
  {
    id: ExactPaySlippageTypes.MAX_SLIPPAGE_0_25,
    name: "0.25%",
  },
  {
    id: ExactPaySlippageTypes.MAX_SLIPPAGE_0_5,
    name: "0.5%",
  },
  {
    id: ExactPaySlippageTypes.MAX_SLIPPAGE_0_75,
    name: "0.75%",
  },
  {
    id: ExactPaySlippageTypes.MAX_SLIPPAGE_1,
    name: "1%",
  },
  {
    id: ExactPaySlippageTypes.MAX_SLIPPAGE_0,
    name: "0%",
  },
];

export const EXACT_PAY_MAX_SLIPPAGE_MAP = {
  [ExactPaySlippageTypes.MAX_SLIPPAGE_0]: 0,
  [ExactPaySlippageTypes.MAX_SLIPPAGE_0_1]: 0.001,
  [ExactPaySlippageTypes.MAX_SLIPPAGE_0_25]: 0.0025,
  [ExactPaySlippageTypes.MAX_SLIPPAGE_0_5]: 0.005,
  [ExactPaySlippageTypes.MAX_SLIPPAGE_0_75]: 0.0075,
  [ExactPaySlippageTypes.MAX_SLIPPAGE_1]: 0.01,
};
